import values from 'lodash.values';
import keys from 'lodash.keys';

const getFilteredDealerOrders = state => {
  const {
    dealer: { filteredAll },
  } = state;
  const filteredDealerIds = keys(filteredAll);
  const ordersDict = state.orders.dict;
  const orders = ordersDict ? values(ordersDict) : [];

  if (filteredDealerIds.length) {
    const filterOrders = order => filteredDealerIds.indexOf(order.dealerId) !== -1;

    return orders.filter(filterOrders);
  }

  return orders;
};

export default getFilteredDealerOrders;



// WEBPACK FOOTER //
// ./src/selectors/get-filtered-dealer-orders.js